import { put, call, takeLatest } from 'redux-saga/effects';
import { fetchBillingAddress, updateBillingAddress } from '../api';
import {
  fetchBillingAddressInitialRequest,
  fetchBillingAddressSuccess,
  fetchBillingAddressFailure,
  updateBillingAddressSuccess,
  updateBillingAddressFailure,
} from '../actions';

import { UPDATE_BILLING_ADDRESS_REQUEST, FETCH_BILLING_ADDRESS_REQUEST } from '../types';

export function* fetchBillingAddressSaga(action) {
  if (!action) {
    yield put(fetchBillingAddressInitialRequest());
  }

  try {
    const { data: response } = yield call(fetchBillingAddress);

    if (!response || !response.success || !response.data) {
      throw new Error();
    }

    yield put(fetchBillingAddressSuccess(response.data));
  } catch (e) {
    yield put(fetchBillingAddressFailure(e));
  }
}
export function* updateBillingAddressSaga(action) {
  try {
    const payload = {
      ...action.payload,
      address2: action.payload.address2 || '',
      address3: action.payload.address3 || '',
    };

    const { data: response } = yield call(updateBillingAddress, payload);

    if (!response || !response.success || !response.data) {
      throw new Error();
    }

    yield put(updateBillingAddressSuccess(response.data));
  } catch (e) {
    yield put(updateBillingAddressFailure(e));
  }
}

const billingAddressSaga = [
  takeLatest(FETCH_BILLING_ADDRESS_REQUEST, fetchBillingAddressSaga),
  takeLatest(UPDATE_BILLING_ADDRESS_REQUEST, updateBillingAddressSaga),
];

export default billingAddressSaga;
